export const admissionsSteps = [
  {
    title: 'Apply',
    description: 'Create your student account, choose an academic pathway, and submit your registration details.'
  },
  {
    title: 'Review',
    description: 'The admissions team reviews your details and confirms the next step for your selected intake.'
  },
  {
    title: 'Onboard',
    description: 'Complete the required payment or admissions-code step, then receive access to orientation and learning.'
  }
];

export const admissionsFaqs = [
  {
    key: 'apply',
    title: 'How do I apply?',
    body: 'Create a student account, select your course in Registration, and follow the application steps shown in the portal.'
  },
  {
    key: 'requirements',
    title: 'What are the requirements?',
    body: 'Students should be ready to participate in weekly learning, assignments, and the School of SHEM community standards.'
  },
  {
    key: 'timeline',
    title: 'How long does approval take?',
    body: 'Applications are reviewed per intake. The admissions team will communicate your status and any outstanding steps.'
  },
  {
    key: 'payment',
    title: 'What payment options are available?',
    body: 'Available payment options are shown during registration and may vary by course or cohort.'
  },
  {
    key: 'start',
    title: 'When do cohorts start?',
    body: 'Start dates are published for each intake and confirmed during onboarding.'
  }
];
